import { subscribeCloudflareEvents } from './cloudflare-events'

export interface DatabaseChangePayload<T extends Record<string, unknown>> {
  new: T
  old: Partial<T>
  eventType: 'INSERT' | 'UPDATE' | 'DELETE'
}

/**
 * Subscribe to row-level Postgres changes scoped to one organization on one table.
 * Returns an unsubscribe function suitable for use in `useEffect` cleanup.
 *
 * @example
 *   useEffect(() => subscribeOrgChannel(orgId, 'projects', (p) => {
 *     queryClient.invalidateQueries({ queryKey: ['projects'] })
 *   }), [orgId])
 */
export function subscribeOrgChannel<T extends Record<string, unknown> = Record<string, unknown>>(
  orgId: string,
  table: string,
  handler: (payload: DatabaseChangePayload<T>) => void,
): () => void {
  return subscribeCloudflareEvents(orgId, null, (event) => {
    if (event.aggregate_type !== table && !event.event_type.toLowerCase().includes(table)) return
    handler({ new: event as unknown as T, old: {}, eventType: 'UPDATE' })
  })
}
